var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product main"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon1"}),_c('div',{staticClass:"icon2"}),_c('div',{staticClass:"icon3"}),_c('img',{staticClass:"code code-an",attrs:{"src":"https://image.xiaoxxx.cn/test/urlGather/202407161c07b0c431f77ee5350570.png","alt":""}})])])
}]

export { render, staticRenderFns }